import { createContext, useState } from 'react';

/* -----------------------  사용 예시  -----------------------

import { useContext } from 'react';
import { StateContexts } from 'context';

function Example() {
  const { example, setExample } = useContext(StateContexts);

  return (
    <div>
      <p>This Is Context useage example</p>
    </div>
  )
}

---------------------------------------------------------- */

const StateContexts = createContext();

function Contexts({ children }) {
  const [english, setEnglish] = useState(false);
  const initialValue = {
    english: english,
    setEnglish: setEnglish,
  };

  return <StateContexts.Provider value={initialValue}>{children}</StateContexts.Provider>;
}

export { Contexts, StateContexts };
